import React, {Component} from 'react';
import moment from 'moment';
import Confirm from '../Dialog/Confirm';
import {tryCheckin} from 'actions/CheckinActions';

class CheckinBlockWithCheckout extends Component {
  state={
    checking: false
  }

  tryCheckin = (label, date, sid, checkout) => {
    return () => {
      this.activeChecking()
      Confirm(`將簽到${date}-${label}更的` + (checkout? "下班卡" : "上班卡"))
        .then(
          () => {
            this.props.dispatch(tryCheckin(date, sid, this.dismissChecking, checkout));
          },
          () => {
            this.dismissChecking()
          }
        );
    }
  }

  activeChecking = () => {
    this.setState({
      checking: true
    })
  }

  dismissChecking = () => {
    this.setState({
      checking: false
    })
  }

  render() {
    let {label, sessionConfig, record, date, sid} = this.props;
    //prepare session data
    let ableAt = moment(date + " " + sessionConfig.get('ableAt'), "YYYY-MM-DD HH:mm");
    let disableAt = moment(date + " " + sessionConfig.get('disableAt'), "YYYY-MM-DD HH:mm");
    disableAt.isBefore(ableAt) && disableAt.add(1, 'days');
    let checkinAt = record.get('checkinAt');
    let checkoutAt = record.get('checkoutAt');
    let isCheckedin = checkinAt !== null && checkinAt !== undefined;
    let isCheckedout = checkoutAt !== null && checkoutAt !== undefined;
    let ActionBlock = (
      <button
        className={"btn " + (isCheckedin ? 'btn-warning' : 'btn-success')}
        onClick={this.tryCheckin(label, date, sid, isCheckedin)}
        disabled={this.state.checking}
      >
        {(this.state.checking ? "加載中" : (isCheckedin? "下班" : "上班"))}
      </button>
    );

    let isActive = true;

    if (!isCheckedin || !isCheckedout) {
      let now = moment();
      if (now.isAfter(disableAt) || now.isBefore(ableAt)) {
        ActionBlock = (<span />);
        isActive = false;
      }
    }

    return (
      <div className={"action " + (isActive ? "active" : "")}>
        <div className="lead">
          <div className="shift-label">
            <span className="label label-primary">
              {label}
            </span>
          </div>
          {sessionConfig.get('startAt')} - {sessionConfig.get('endAt')}
        </div>
        <h1>{record.get('siteName') || '沒有任何編更記錄'}</h1>
        {isCheckedin &&
          <div>
            <span className="info">{`已於 ${checkinAt} 打上班卡`}</span>
          </div>
        }
        <div className={!isCheckedout ? (isCheckedin ? 'checkin-btn--right' : 'checkin-btn--left') : ''}>
          {(isCheckedout? <span className="info">{`已於 ${checkoutAt} 打下班卡`}</span> : ActionBlock)}
        </div>
      </div>
    )
  }
}

export default CheckinBlockWithCheckout;



// WEBPACK FOOTER //
// ./src/components/Checkin/CheckinBlockWithCheckout.js